import api from '../api/api.js'

export default {
  namespaced: true,

  state: {
    itemId: '',
    skuId: '',
    lifeCycle: 0,
    item: {},
    skus: {},
    mainItem: {},
    mainSku: {},
    suggestState: true,
    predictState: true,
    salesSum: '',
    salesAmount: '',
    profit: '',
    stock: '',
    consumption: '',
    setOffrate: '',
    customSalesSum: '',
    customSalesAmount: '',
    customProfit: '',
    customStock: '',
    customConsumption: 0
  },

  getters: {
    skuId(state) {
      if (!state.skus[state.skuId]) return
      return state.skuId
    },
    itemId(state) {
      return state.itemId
    },
    lifeCycle(state) {
      return state.lifeCycle
    },
    item(state) {
      return state.item
    },
    skus(state) {
      return state.skus
    },
    suggestState(state) {
      return state.suggestState
    },
    salesSum(state) {
      return state.salesSum.toLocaleString()
    },
    salesAmount(state) {
      return state.salesAmount.toLocaleString()
    },
    profit(state) {
      return state.profit.toLocaleString()
    },
    stock(state) {
      return state.stock.toLocaleString()
    },
    consumption(state) {
      return state.consumption ? state.consumption + '%' : ''
    },
    setOffrate(state) {
      return state.setOffrate
    },
    customSalesSum(state) {
      return state.customSalesSum.toLocaleString()
    },
    customSalesAmount(state) {
      return state.customSalesAmount.toLocaleString()
    },
    customProfit(state) {
      return state.customProfit.toLocaleString()
    },
    customStock(state) {
      return state.customStock.toLocaleString()
    },
    customConsumption(state) {
      return state.customConsumption ? state.customConsumption + '%' : ''
    },
    predictState(state) {
      return state.predictState
    },
    mainSku(state) {
      return state.mainSku
    }
  },

  mutations: {
    selectItem(state, params) {
      state.itemId = params.itemId
      state.skuId = params.skuId
    },
    predict(state, params) {
      state.lifeCycle = params.lifeCycle
      state.item = params.item
      state.skus = params.skus
      state.mainItem = params.item
      state.mainSku = params.skus
      state.item['accum_arrival'] = params.item['accum_arrival']
      state.item['off_rates'] = params.item['off_rates']
      for (const sku in state.skus) {
        state.skus[sku]['off_rates'] = params.skus[sku]['off_rates']
        state.skus[sku]['accum_arrival'] = params.skus[sku]['accum_arrival']
      }
    },
    actualWeek(state, param) {
      state.actualWeek = param
    },
    customItem(state, params) {
      state.item['custom_sales'] = params.item['custom_sales']
      state.item['accum_arrival'] = params.item['custom_accum_arrival']
      state.item['off_rates'] = params.item['custom_off_rates']
      state.item['custom_sales_sum'] = params.item['custom_sales_sum']
      state.item['custom_sales_amount'] = params.item['custom_sales_amount']
      state.item['custom_profit'] = params.item['custom_profit']
      state.item['custom_stock'] = params.item['custom_stock']
      state.item['custom_consumption'] = params.item['custom_consumption']
      for (const sku in params.skus) {
        state.skus[sku]['custom_sales'] = params.skus[sku]['custom_sales']
        state.skus[sku]['accum_arrival'] = params.skus[sku]['custom_accum_arrival']
        state.skus[sku]['off_rates'] = params.skus[sku]['custom_off_rates']
        state.skus[sku]['custom_sales_sum'] = params.skus[sku]['custom_sales_sum']
        state.skus[sku]['custom_sales_amount'] = params.skus[sku]['custom_sales_amount']
        state.skus[sku]['custom_profit'] = params.skus[sku]['custom_profit']
        state.skus[sku]['custom_stock'] = params.skus[sku]['custom_stock']
        state.skus[sku]['custom_consumption'] = params.skus[sku]['custom_consumption']
      }
    },
    customSku(state, params) {
      const skuId = params.skuId
      state.skus[skuId]['custom_sales'] = params.skus[skuId]['custom_sales']
      state.skus[skuId]['accum_arrival'] = params.skus[skuId]['custom_accum_arrival']
      state.skus[skuId]['off_rates'] = params.skus[skuId]['custom_off_rates']

      state.skus[skuId]['custom_sales_sum'] = params.skus[skuId]['custom_sales_sum']
      state.skus[skuId]['custom_sales_amount'] = params.skus[skuId]['custom_sales_amount']
      state.skus[skuId]['custom_profit'] = params.skus[skuId]['custom_profit']
      state.skus[skuId]['custom_stock'] = params.skus[skuId]['custom_stock']
      state.skus[skuId]['custom_consumption'] = params.skus[skuId]['custom_consumption']
    },
    customPredictStateItem(state) {
      state.customSalesSum = state.item['custom_sales_sum']
      state.customSalesAmount = state.item['custom_sales_amount']
      state.customProfit = state.item['custom_profit']
      state.customStock = state.item['custom_stock']
      state.customConsumption = state.item['custom_consumption']
    },
    customPredictStateSku(state) {
      state.customSalesSum = state.skus[state.skuId]['custom_sales_sum']
      state.customSalesAmount = state.skus[state.skuId]['custom_sales_amount']
      state.customProfit = state.skus[state.skuId]['custom_profit']
      state.customStock = state.skus[state.skuId]['custom_stock']
      state.customConsumption = state.skus[state.skuId]['custom_consumption']
    },
    predictStateItem(state) {
      state.salesSum = state.item['sales_sum']
      state.salesAmount = state.item['sales_amount']
      state.profit = state.item['profit']
      state.stock = state.item['stock']
      state.consumption = state.item['consumption']
      state.setOffrate = state.item['set_offrate']
    },
    predictStateSku(state) {
      state.salesSum = state.skus[state.skuId]['sales_sum']
      state.salesAmount = state.skus[state.skuId]['sales_amount']
      state.profit = state.skus[state.skuId]['profit']
      state.stock = state.skus[state.skuId]['stock']
      state.consumption = state.skus[state.skuId]['consumption']
      state.setOffrate = state.skus[state.skuId]['set_offrate']
    },
    suggestStart(state) {
      state.suggestState = false
    },
    suggestEnd(state) {
      state.suggestState = true
    },
    predictState(state) {
      state.predictState = false
    },
    reset(state) {
      state.predictState = true
      state.salesSum = ''
      state.salesAmount = ''
      state.profit = ''
      state.stock = ''
      state.consumption = ''
      state.setOffrate = ''
      state.customSalesSum = ''
      state.customSalesAmount = ''
      state.customProfit = ''
      state.customStock = ''
      state.customConsumption = ''
    },
    resetList(state) {
      state.itemId = ''
      state.skuId = ''
      state.predictState = true
      state.item = {}
      state.skus = {}
    }
  },

  actions: {

    /**
     * item単位の予測
     */
    getPredictItem({ commit }, payload) {
      commit('suggestStart')

      const data = {
        item_id: payload.itemId
      }

      api.get('/api/v2/predict/get', data)
        .then((res) => {
          const item = res.data.item
          const skus = res.data.sku

          commit('reset')
          commit('selectItem', {
            itemId: payload.itemId,
            skuId: ''
          })
          commit('predict', {
            lifeCycle: item.life_cycle,
            item: item,
            skus: skus,
          })
          commit('predictStateItem')
        })
        .finally(() => {
          commit('suggestEnd')
        })
    },

    /**
     * item単位の予測
     * sku一覧の「全て」行の選択時のみ
     * API問い合わせはせず、item単位に切り替え
     */
    getPredictSelectItem({ state, commit }, itemId) {
      let id = itemId
      if (!id) id = state.itemId

      commit('selectItem', {
        itemId: id,
        skuId: ''
      })

      commit('predictStateItem')
      if (state.item['custom_consumption']) {
        commit('customPredictStateItem')
        commit('predictState')
      }
    },

    /**
     * sku単位の予測
     * API問い合わせは行わない
     */
    getPredictSku({ state, commit }, skuId) {
      const skus = state.skus

      if (skus[skuId]) {
        commit('reset')
        commit('selectItem', {
          itemId: state.itemId,
          skuId: skuId
        })

        commit('predictStateSku')
        if (skus[skuId]['custom_consumption']) {
          commit('customPredictStateSku')
          commit('predictState')
        }
      }
    },

    /**
     * item単位の追加発注サジェスション
     */
    getSuggestOrder({ state, commit }, payload) {
      commit('suggestStart')

      const data = {
        item_id: state.itemId,
        suggest_type: 4
      }

      return api.get('/api/v2/suggest/order/item/get', data)
        .then((res) => {
          const item = res.data.item
          const skus = res.data.sku
          if (_.size(item) === 0) return

          commit('reset')
          commit('customItem', {
            item: item,
            skus: skus
          })

          commit('predictStateItem')
          commit('customPredictStateItem')
          commit('predictState')
        })
        .finally(() => {
          commit('suggestEnd')
        })
    },

    /**
     * sku単位の追加発注サジェスション
     */
    getSuggestOrderSku({ state, commit }, payload) {
      commit('suggestStart')

      const skuId = state.skuId
      const data = {
        sku_id: skuId,
        suggest_type: 4
      }

      return api.get('/api/v2/suggest/order/sku/get', data)
        .then((res) => {
          const sku = res.data.sku
          if (_.size(sku) === 0) return

          commit('reset')
          commit('customSku', {
            skuId: skuId,
            skus: sku
          })

          commit('predictStateSku')
          commit('customPredictStateSku')
          commit('predictState')
        })
        .finally(() => {
          commit('suggestEnd')
        })
    },

    /**
     * item単位のマークダウンサジェスション
     */
    getSuggestDiscount({ state, commit }, payload) {
      commit('suggestStart')

      const data = {
        item_id: state.itemId,
        suggest_type: 1
      }

      return api.get('/api/v2/suggest/discount/item/get', data)
        .then((res) => {
          const item = res.data.item
          const skus = res.data.sku
          if (_.size(item) === 0) return

          commit('reset')
          commit('customItem', {
            item: item,
            skus: skus
          })

          commit('predictStateItem')
          commit('customPredictStateItem')
          commit('predictState')
        })
        .finally(() => {
          commit('suggestEnd')
        })
    },

    /**
     * sku単位のマークダウンサジェスション
     */
    getSuggestDiscountSku({ state, commit }, payload) {
      commit('suggestStart')

      const skuId = state.skuId
      const data = {
        sku_id: skuId,
        suggest_type: 1
      }

      return api.get('/api/v2/suggest/discount/sku/get', data)
        .then((res) => {
          const sku = res.data.sku
          if (_.size(sku) === 0) return

          commit('reset')
          commit('customSku', {
            skuId: skuId,
            skus: sku
          })

          commit('predictStateSku')
          commit('customPredictStateSku')
          commit('predictState')
        })
        .finally(() => {
          commit('suggestEnd')
        })
    },

    /**
     * item単位のカスタム予測
     */
    getCustomItem({ state, commit }, payload) {
      commit('suggestStart')

      const data = {
        item_id: state.itemId,
        custom_param: payload.data
      }

      return api.post('/api/v2/custom/item/get', data)
        .then((res) => {
          const item = res.data.item
          const skus = res.data.sku

          commit('reset')
          commit('customItem', {
            item: item,
            skus: skus
          })

          commit('predictStateItem')
          commit('customPredictStateItem')
          commit('predictState')
        })
        .finally(() => {
          commit('suggestEnd')
        })
    },

    /**
     * sku単位のカスタム予測
     */
    getCustomSku({ state, commit }, payload) {
      commit('suggestStart')
      const data = {
        sku_id: payload.skuId,
        custom_param: payload.data
      }

      return api.post('/api/v2/custom/sku/get', data)
        .then((res) => {
          const sku = res.data.sku

          commit('reset')
          commit('customSku', {
            skuId: payload.skuId,
            skus: sku
          })

          commit('predictStateSku')
          commit('customPredictStateSku')
          commit('predictState')
        })
        .finally(() => {
          commit('suggestEnd')
        })
    },

    /**
     * 初期化
     */
    resetPredict({ commit }) {
      commit('reset')
      commit('resetList')
    }
  }
}



// WEBPACK FOOTER //
// ./src/vuex/module/predict.js